<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="inspectContent">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 点检内容项
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="searchForm1">
          <el-form ref="seefrom" class="uLabelDcontent" :model="seefrom">
            <el-form-item label="消防系统">
              <el-select :popper-append-to-body="false" v-model="seefrom.fireControlSystem" placeholder="请选择消防系统" clearable>
                <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型:">
              <el-input placeholder="请输入设备类型" v-model="seefrom.deviceType"></el-input>
            </el-form-item>
            <el-form-item label="到期提醒">
              <el-select :popper-append-to-body="false" v-model="seefrom.isFrequency" placeholder="请选择" clearable>
                <el-option v-for="item in remindList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <add-edit-dialog v-model="addModal" :status="addStatus" :data="detailData" @refresh="getTableData"></add-edit-dialog>
  </div>
</template>

<script>
import addEditDialog from './addEditDialog'
export default {
  name: 'inspectContent',
  data() {
    return {
      tabName: 'inspectContent',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      addModal: false,
      addStatus: 'adding',
      detailData: {},
      systemList: [],
      remindList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ]
    }
  },
  components: {
    addEditDialog
  },
  computed: {
    config() {
      return [
        {
          prop: 'fireControlSystem',
          label: '消防系统'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'inspectionStandard',
          label: '检查标准'
        },
        {
          prop: 'inspectionMethod',
          label: '检查方法'
        },
        {
          prop: 'inspectionResult',
          label: '检查结果'
        },
        {
          prop: 'frequencyName',
          label: '到期提醒'
        }
      ]
    }
  },
  mounted() {
    this.getTableData()
    this.getSystemList()
  },
  methods: {
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    reset() {
      this.seefrom = {}
    },
    getTableData() {
      this.$axiosget('extra/pointInspectContentItem/page', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableData = res.data.data.list.map((item) => {
          return {
            ...item,
            frequencyName: this.remindList.find(
              (fItem) => fItem.value == item.isFrequency
            ).label
          }
        })
        this.nTotal = res.data.data.total
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    //新增
    addnew() {
      this.addStatus = 'adding'
      this.addModal = true
    },
    // 编辑
    edit(row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.addModal = true
    },
    deleteMsg(row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/pointInspectContentItem', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    }
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/inspectContent/index.vue